import accounting from 'accounting'

const Filters = {
  install(Vue) {
    Vue.filter('nl2br', (value) => String(value).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2'))

    Vue.filter('externalUrl', (url) => {
      if (!url) {
        return url
      }

      if (url[0] === '/' || url[0] === '#') {
        return url
      }

      if (!/^[\w+.-]+:\/\//m.test(url)) {
        return `http://${url}`
      }

      return url
    })

    Vue.filter('dollars', (value, precision = 2) => {
      return accounting.formatMoney(value, '$', precision)
    })
  },
}

export default Filters
